import { SelfEvaluationRecord } from "src/app/self-evaluation/_interfaces/self-evaluation-record.interface";
import { AttributeItem } from "src/app/users/_interfaces/users-admin";

export interface ManagedUser {
    userId: string;
    cycleParticipantId?: number;
    imageUrl: string;
    name: string;
    lineManager: string;
    lineManager2: string;
    relationship: string;
    status: FinalEvaluationStatus;
    selfEvaluationStatus: FinalEvaluationStatus;
    attributes?: AttributeItem[];
    selfEvaluation?: SelfEvaluationRecord;
    
    rank?: string;
    area?: string;
}

export enum FinalEvaluationStatus {
    NotSent = 0,
    Sent = 1
}
